import {
  apptHistoryUserName,
  formatTimeStr,
  formatDateStr,
  formatISODateStr,
  formatDateStrWithYear,
  formatDateStrWithYearShort,
  formatExactTimestamp,
} from '../../utils';
import { formatPrice } from '../helpers';

angular
  .module('bb.util')
  .filter('formatstatus', formatStatus)
  .filter('uppercase', uppercase)
  .filter('allUppercase', allUppercase)
  .filter('bbApptHistoryUserName', bbApptHistoryUserName)
  .filter('bbCurrencyFormat', bbCurrencyFormat)
  .filter('appointmentStatusProperCase', appointmentStatusProperCase)
  .filter('bbTimeStr', bbTimeStr)
  .filter('bbDateStr', bbDateStr)
  .filter('bbISODateStr', bbISODateStr)
  .filter('bbDateStrWithYear', bbDateStrWithYear)
  .filter('bbDateStrWithYearShort', bbDateStrWithYearShort)
  .filter('bbDateStrWithExactTimestamp', bbDateStrWithExactTimestamp);

const statusMap = {
  new: 'new',
  attempted: 'attempted',
  confirm: 'confirmed',
  deny: 'denied',
  cancel: 'cancelled',
  time_change: 'time_changed',
  time_passed: 'time_passed',
};
function formatStatus() {
  return (input, isPastTense) => {
    if (!input) return input;
    if (input === 'pending_multi_conf') return 'Pending - Waiting For Others';
    if (input === 'suggested_time_change') return 'Suggested Time Change';
    if (statusMap[input] && isPastTense) {
      input = statusMap[input];
    }
    return input.replace(/_/g, ' ').replace(/(^| )(\w)/g, x => x.toUpperCase());
  };
}

function uppercase() {
  return string => {
    if (!string) return string;

    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
}

// The above filter overwrote the default uppercase, so now we have this.
function allUppercase() {
  return string => {
    if (!string) return string;
    return string.toUpperCase();
  };
}

function bbCurrencyFormat() {
  return formatPrice;
}

function appointmentStatusProperCase() {
  return string => {
    const DISPLAY_STATUSES = {
      config_change: 'Config Change',
      time_change: 'Time Change',
      time_passed: 'Time Passed',
      attempted: 'Attempted',
      cancel: 'Cancelled',
      confirm: 'Confirmed',
      deny: 'Denied',
      new: 'New',
      removed: 'Removed',
    };
    if (!string) return string;

    return DISPLAY_STATUSES[string];
  };
}

function bbApptHistoryUserName() {
  return apptHistoryUserName;
}

function bbTimeStr() {
  return formatTimeStr;
}

function bbDateStr() {
  return formatDateStr;
}

function bbISODateStr() {
  return formatISODateStr;
}

function bbDateStrWithYear() {
  return formatDateStrWithYear;
}

function bbDateStrWithYearShort() {
  return formatDateStrWithYearShort;
}

function bbDateStrWithExactTimestamp() {
  return formatExactTimestamp;
}

bbCurrencyFormat.$inject = ['$filter'];
